import React, { useRef, useState } from 'react';
import { Button, Popover, Input, InputRef } from '@myua/kit';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { AddCircle } from '@myua/icons/dist/bulk16';
import { useDispatch, useSelector } from 'react-redux';
import * as tagActions from '../actions';
import { getPermissions } from '../../app/selectors';
import { Permission } from '../../../../general/model';

export const RequestTag = () => {
  const dispatch = useDispatch();
  const ref = useRef<InputRef>(null);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  const permissions = useSelector(getPermissions);
  if (!permissions[Permission['fs.assetlab_create_tag']]) {
    return null;
  }

  return (
    <Popover
      trigger="click"
      open={open}
      onOpenChange={(newOpen) => {
        if (newOpen) {
          setText('');
          setTimeout(() => ref.current?.focus(), 0);
        }
        setOpen(newOpen);
      }}
      content={
        <div className="al-tag-request-popover">
          <Input ref={ref} maxLength={120} value={text} onChange={(e) => setText(e.target.value)} />
          <Button
            type="primary"
            icon={<CheckOutlined />}
            disabled={!text.trim()}
            onClick={() => {
              setOpen(false);
              dispatch(tagActions.tagRequested({ name: text.trim() }));
            }}
          />
          <Button icon={<CloseOutlined />} onClick={() => setOpen(false)} />
        </div>
      }
    >
      <Button className="al-tag-request-button" type="primary" icon={<AddCircle />}>
        New tag
      </Button>
    </Popover>
  );
};
